export const TipoTurno = Object.freeze({
    laborable:"Laborable",
    dia_descanso:"Día de descanso",
    horas_extras:"Horas extras",
    SEMANAL:"SEMANAL",
    MENSUAL:"MENSUAL",
    ROTATIVOS:"ROTATIVOS",
})